export function QueryGetValue (searchParam) {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    return urlParams.get(searchParam)
}